import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {ExpAccDetailReportData} from "./exp-acc-detail-report.data";

@Injectable()
export class ExpAccDetailReportModel extends ReportModel<ExpAccDetailReportData> {
    constructor(injector: Injector) {
        super(injector, ExpAccDetailReportData);
    }
}
